import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '@/components/ui/Tabs/Tabs';
import Fund from '@/models/Fund';
import { FundStatus } from '@/models/common/FundStatus';
import { useGetAuthApi } from '@/hooks/UseApiCalls';
import FundFilter from '@/components/filters/FundFilter/FundFilter';
import UploadSupportedsTab from './UploadSupportedsTab';
import UploadSupportRequestsTab from './UploadSupportRequestsTab';
import styles from './shared/SharedStyles.module.css';

const REGISTERED_FUNDS_URL = `funds/management?status=${FundStatus.Active}`;

export default function BulkUploadsPage() {
  const { t } = useTranslation();

  // This page lives in the global management area (no fund context), so the
  // target fund for the upload is picked explicitly here. The list comes from the funds
  // registered in this system rather than from every fund in the accounting system: the upload
  // is rejected for a fund that has no record here, so offering one is a dead end (HAT-1276).
  const [targetFundId, setTargetFundId] = useState<number | null>(null);
  const { data: funds } = useGetAuthApi<Fund[]>(REGISTERED_FUNDS_URL);
  const targetFund = targetFundId != null ? (funds?.find((f) => f.id === targetFundId) ?? null) : null;

  return (
    <div>
      <div className={styles.targetFundBar}>
        <span className="body-md-semibold">{t('bulkUploads.targetFund')}</span>
        <FundFilter
          selectedFundId={targetFundId}
          onFundChange={setTargetFundId}
          fundsApiUrl={REGISTERED_FUNDS_URL}
        />
      </div>
      <Tabs defaultValue="supporteds" style={{ direction: 'rtl' }}>
        <TabsList>
          <TabsTrigger value="supporteds">{t('bulkUploads.tabSupporteds')}</TabsTrigger>
          <TabsTrigger value="supportRequests">{t('bulkUploads.tabSupportRequests')}</TabsTrigger>
        </TabsList>
        <TabsContent value="supporteds">
          <UploadSupportedsTab targetFund={targetFund} />
        </TabsContent>
        <TabsContent value="supportRequests">
          <UploadSupportRequestsTab targetFund={targetFund} />
        </TabsContent>
      </Tabs>
    </div>
  );
}
